import React from "react";
import { ContextLanguage } from "../../../context/Context.Language";
import {
  STATUS_ORDER_CANCELED,
  STATUS_ORDER_COMPLETED,
  STATUS_ORDER_PROCESSING,
  TEXT_CANCELED,
  TEXT_CANCELLED,
  TEXT_COMPLETED,
  TEXT_INPROCESS,
} from "../../../utils/useConstants";
import { STATE_CONSTANTS_STATUS } from "../../../utils/useConstantState";
import {
  STYLE_CENCELED,
  STYLE_COMPLETE,
  STYLE_INPROCESS,
} from "../../../utils/useStyle";

export const OPTIONS_STATUS_NEW = [
  {
    value: "IN_PROCESS",
    label: "IN PROCESS - ดำเนินการอยู่",
  },
  {
    value: "PICK_UP_ASSIGNED",
    label: "Pick-Up assigned - จัดผู้ไปรับแล้ว",
  },
  {
    value: "PICK_UP_FROM_CUSTOMER",
    label: "Picked-Up from Customer - รับจากลูกค้าแล้ว",
  },
  {
    value: "REACHED_PATTAYA",
    label: "Reached Pattaya - ถึงร้านพัทยาแล้ว",
  },
  {
    value: "REACHED_BANGKOK",
    label: "Reached Bangkok - ถึงร้านกรุงเทพแล้ว",
  },
  {
    value: "CLEANING_IN_PROCESS",
    label: "Cleaning in Process – ดำเนินการซักอยู่",
  },
  {
    value: "READY_FOR_RETURN",
    label: "Ready for Return (Water?) - พร้อมจัดส่งคืน (น้ำดื่ม?)",
  },
  {
    value: "RETURN_ASSIGNED",
    label: "Return assigned",
  },
  {
    value: "COMPLETED",
    label: "COMPLETED - เรียบร้อยแล้ว",
  },
  {
    value: "CANCELLED",
    label: "CANCELLED - ยกเลิกแล้ว",
  },
];

const OrderGetStyleStatus = ({ input }) => {
  const { language } = React.useContext(ContextLanguage);
  if (
    OPTIONS_STATUS_NEW.slice(0, 8)
      .map((r) => {
        return r.value;
      })
      .includes(input)
  ) {
    return (
      <div className={`${STYLE_INPROCESS(language)}`}>
        {TEXT_INPROCESS[language]}
      </div>
    );
  } else if (input === "COMPLETED") {
    return (
      <div className={STYLE_COMPLETE(language)}>{TEXT_COMPLETED[language]}</div>
    );
  } else if (input === "CANCELLED") {
    return (
      <div className={STYLE_CENCELED(language)}>{TEXT_CANCELLED[language]}</div>
    );
  } else {
    return <div className={STYLE_CENCELED(language)}>{`ERROR`}</div>;
  }
};

export default OrderGetStyleStatus;
